import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Modal } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import './Exam.css';
function Exam( {nextSchedules}) {
    const costsOvernight = '1149,00 € + 89,00 € pro Nacht = 1505,00 €';
    const costsNormal = '1149,00 €';

    const [isOvernight, setIsOvernight] = useState(false);
    const [cost, setCost] = useState(costsNormal);
    const [selectedDate, setSelectedDate] = useState('');

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
    });

    const [captchaValue, setCaptchaValue] = useState(null);
    const [showModal, setShowModal] = useState(false); // State für das Modal

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prevData) => ({...prevData, [name]: value}));
    };

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const handleOvernightChange = () => {
        setIsOvernight(!isOvernight);
        if (!isOvernight) {
            setCost(costsOvernight);
        } else {
            setCost(costsNormal);
        }
    };

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (captchaValue) {
            console.log('Form data submitted:', formData);
            // Weitere Logik hier
        } else {
            alert('Bitte bestätigen Sie, dass Sie kein Roboter sind!');
        }
    };

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    return (
            <>
            <Container className="text-white mt-5 mb-4">
                <Row className="mt-2">
                    <Col>
                    <div className="blur-section-red p-3 rounded">
                        <Row>
                            <Col className="d-flex justify-content-center">
                            <h2>
                                KRAV MAGA INSTRUCTOR
                            </h2>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col>
                            <div className="d-flex justify-content-start">
                                <p>
                                    Deine Ausbildungswoche endet mit der anspruchsvollen Prüfung zum KRAV MAGA INSTRUCTOR. 
                                    Nach intensiven Tagen hast Du die Chance, sowohl Deine Mitstreiter als auch die 
                                    Prüfer von Deinem Können zu überzeugen. Unsere Abschlussprüfungen fordern Höchstleistung – 
                                    und wenn Du bestehst, kannst Du Dir sicher sein, dass Deine Fähigkeiten einem 
                                    fortgeschrittenen Standard entsprechen.<br/> 
                                    Es ist uns wichtig zu betonen: Nicht jeder besteht nur, weil er teilgenommen hat. 
                                    Unser Qualitätssiegel steht für exzellente Fähigkeiten in der Krav Maga-Selbstverteidigung 
                                    und garantiert höchste Kompetenz.
                                </p>                
                            </div>                
                            </Col>
                        </Row>
            
                        <Row className='mt-4 mb-0'>
                            <Col className="d-flex justify-content-center">
                            <h2>
                                TSKM Kontaktkampf Anleiter
                            </h2>
                            </Col>
                        </Row>
                        <Row className='mt-0'>
                            <Col className="d-flex justify-content-center">
                            <h5 className='text-danger'>
                                !! kostenloser Bonus !!
                            </h5>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col>
                            <div className="d-flex justify-content-start">
                                <p>
                                    Nach erfolgreichem Bestehen der Prüfung zum KRAV MAGA INSTRUCTOR 
                                    wirst Du zusätzlich im KM-System TSKM KONTAKTKAMPF in das Modul 4: violettes Abzeichen eingestuft. 
                                    TSKM KONTAKTKAMPF ist ein taktisches Selbstverteidigungssystem, das seine Wurzeln in 
                                    Krav Maga hat und es durch seinen Fokus auf Anwendung/Sparring eng mit Kickboxen und Karate 
                                    in seinem Grundkonzept vereint. 
                                    <br/>
                                    Für Deine Budo-Reise bedeutet das, dass Du nun doppelt zertifiziert bist – sowohl im Krav Maga 
                                    als auch im TSKM KONTAKTKAMPF. Zudem hast Du die Möglichkeit, Dich nach dem Regelwerk des 
                                    TSKM KONTAKTKAMPF im Graduierungssystem weiter zu qualifizieren und Deine Fähigkeiten weiter auszubauen. 
                                </p>                
                            </div>                
                            </Col>
                        </Row>
            
                        <Row className='mt-4' id='buchung'>
                            <Col className="d-flex justify-content-center">
                            <Card style={{
                                            width: '18rem',
                                            margin: '10px',
                                            textAlign: 'center',
                                            background: 'linear-gradient(to bottom, #bbbbbb, #dddddd)',
                                            border: 'none'
                                              }}>
                            <div className="rounded-top border-bottom border-danger" style={{
                                    background: 'linear-gradient(to bottom, #cc0000, #ff0000)',
                                    color: 'white',
                                    padding: '15px',
                                    fontSize: '24px',
                                    fontWeight: 'bold'
                                     }}>
                                <div style={{
                                        color: '#dfdfdf',
                                        padding: '0px',
                                        fontSize: '15px',
                                        fontWeight: 'bolder'
                                         }}>
                                    Nächste Ausbildung
                                </div>
                                10. - 15. April 2025
                            </div>
                            <Card.Body>
                                <Card.Title className="fw-bold">KRAV MAGA INSTRUCTOR</Card.Title>
                                <Card.Text className="mb-0">
                                    <ul className='mt-2' style={{listStyleType: 'none', padding: 0, textAlign: 'left'}}>
                                        <li>✔ FULL INSTRUCTOR (civil)</li>
                                        <li>✔ Keine Verbandsgebühren</li>
                                        <li>✔ Keine Mitgliedschaften</li>
                                        <li>✔ 6-Tage-kompakt-Ausbildung</li>
                                        <li>✔ optional mit Übernachtung</li>
                                        <li>✔ Erste-Hilfe-Kurs inkl.</li>
                                        <div className="mt-3 fw-bold fs-6" style={{marginLeft: '-5px'}}>Bonus inkl.:</div>
                                        <li className="mt-2">✔ Anleiter TSKM KONTAKTKAMPF</li>
                                        <div className="d-flex justify-content-center mt-3 fs-3 fw-bold">
                                        ab 1149,00€
                                        </div>
                                    </ul>
                                </Card.Text>
                                <Button variant="danger" onClick={handleShow}>
                                    Jetzt verbindlich buchen
                                </Button>
                            </Card.Body>
                            </Card>
                            </Col>
                        </Row>
                    </div>
                    </Col>
                </Row>
            </Container>
            
            <Modal show={showModal} onHide={handleClose} centered dialogClassName="border border-dark rounded">
                <Modal.Header closeButton >
                    <Modal.Title>Buchung</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container className="mt-2 mb-4">
                        <Row className="justify-content-center">
                            <Col md={12}>
                            <div className="blur-section-red p-3 rounded text-white">
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group controlId="formFirstName" className="mb-3">
                                        <Form.Label>Vorname</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Gib Deinen Vornamen ein"
                                            name="firstName"
                                            value={formData.firstName}
                                            onChange={handleChange}
                                            />
                                    </Form.Group>
            
                                    <Form.Group controlId="formLastName" className="mb-3">
                                        <Form.Label>Nachname</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Gib Deinen Nachnamen ein"
                                            name="lastName"
                                            value={formData.lastName}
                                            onChange={handleChange}
                                            />
                                    </Form.Group>
            
                                    <Form.Group controlId="formEmail" className="mb-3">
                                        <Form.Label>E-Mail</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Gib Deine E-Mail-Adresse ein"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            />
                                    </Form.Group>
            
                                    <Form.Group controlId="formTelefon" className="mb-3">
                                        <Form.Label>Telefon</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Gib Deine Telefonnummer ein"
                                            name="telefon"
                                            value={formData.telefon}
                                            onChange={handleChange}
                                            />
                                    </Form.Group>
            
                                    <Form.Group controlId="formStrasse" className="mb-3">
                                        <Form.Label>Strasse + Nummer</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Gib Deinen Strassennamen und Hausnummer ein"
                                            name="strasse"
                                            value={formData.strasse}
                                            onChange={handleChange}
                                            />
                                    </Form.Group>
            
                                    <Form.Group controlId="formPlz" className="mb-3">
                                        <Form.Label>PLZ</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Gib Deine Postleitzahl ein"
                                            name="plz"
                                            value={formData.plz}
                                            onChange={handleChange}
                                            />
                                    </Form.Group>
            
                                    <Form.Group controlId="formOrt" className="mb-3">
                                        <Form.Label>Ort</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Gib Deine Ortsbezeichnung ein"
                                            name="ort"
                                            value={formData.ort}
                                            onChange={handleChange}
                                            />
                                    </Form.Group>
            
                                    <Form.Group controlId="formDate" className="mb-3">
                                        <Form.Label>Ausbildungszeitraum</Form.Label>
                                        <Form.Control
                                            as="select"
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                            >
                                            <option value="">
                                                Wähle Deinen Termin aus...
                                            </option>
                                            {nextSchedules.map((schedule) => (
                                <option
                                    key={schedule.id}
                                    value={schedule.schedule}
                                    >
                                    {schedule.schedule}
                                </option>
                                                            ))}
                                        </Form.Control>
                                    </Form.Group>
            
                                    <Form.Group controlId="formExperience" className="mb-3">
                                        <Form.Label>Vorerfahrung</Form.Label>
                                        <Form.Control
                                            as="textarea" 
                                            rows={4} 
                                            placeholder="Über welche Vorerfahrung in Krav Maga oder Kampfkunst/-sport verfügst Du? Bitte schreibe detailliert, damit wir in Deinen Sinne über eine Teilnahmevoraussetzung entscheiden können."
                                            name="experience"
                                            value={formData.experience}
                                            onChange={handleChange}
                                            />
                                </Form.Group>
            
                                <Form.Group controlId="formAgreeToTerms" className="mb-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Ich stimme den AGBs und Datenschutzbestimmungen zu"
                                        name="agreeToTerms"
                                        checked={formData.agreeToTerms}
                                        onChange={handleChange}
                                        />
                                </Form.Group>
            
                                <Form.Group controlId="formAgreeToHealth" className="mb-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Ich bestätige, dass ich gesundheitlich uneingeschränkt fit bin"
                                        name="agreeToHealth"
                                        checked={formData.agreeToHealth}
                                        onChange={handleChange}
                                        />
                                </Form.Group>
            
                                <Form.Group controlId="formYesToHotel" className="mb-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="inklusive vier Übernachtungen im Hotel"
                                        name="yesToHotel"
                                        checked={isOvernight}
                                        onChange={handleOvernightChange}
                                        />
                                </Form.Group>
            
                                <Form.Group controlId="formCost">
                                    <Form.Label>Kosten</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="kosten"
                                        value={`${cost}`}
                                        readOnly
                                        />
                                </Form.Group>
            
                                <Row className="align-items-center mt-4 mb-4">
                                    <Col md={12} className="mb-3">
                                    <small>
                                        - Wir kooperieren mit dem{' '}
                                        <a
                                            href="https://www.hotel-waldkur.de"
                                            target="blank"
                                            className="text-danger"
                                            >
                                            Hotel Waldkur
                                        </a>{' '}
                                        (ca. 10km entfernt).
                                        <br />
                                        - Deine Zahlung erfolgt nach
                                        Rechnungsstellung zu den angegebenen
                                        Fristen.
                                    </small>
                                    </Col>
                                </Row>
            
                                <Row className="align-items-center mt-2 mb-2">
                                    <Col md={12} className="mb-3 d-flex justify-content-center">
                                    <ReCAPTCHA
                                        sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                                        onChange={handleCaptchaChange}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} className="mb-2 d-flex justify-content-center">
                                    <Button variant="success" type="submit" className="w-75 p-4">
                                        Verbindlich buchen
                                    </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            </Modal>
            </>


            );
}

export default Exam;
